import type { Translate } from "../i18n/locale";

/** La fase di un'opportunità con le parole di Close (SEZ-9); una fase che il catalogo non conosce resta com'è. */
export function stageText(t: Translate, stage: string): string {
  switch (stage) {
    case "disco_booked":
    case "disco_held":
    case "demo_booked":
    case "demo_held":
    case "sold":
    case "lost":
      return t(`appointments.stages.${stage}`);
    default:
      return stage;
  }
}
